import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { resendEmail } from "../_redux/authAPI";
import toasters from "../../../../utils/toasters/Toasters";

const ResendEmail = () => {
  const location = useLocation();
  const { message, username } = location.state || {};
  const [loading, setLoading] = useState(false);

  const { mutate } = useMutation(resendEmail, {
    onSuccess: () => {
      toasters({ type: "success", message: "Email resent successfully" });
    },
    onError: (error) => {
      const errMsg =
        error?.response?.data?.message || "Failed to resend email";
      toasters({ type: "error", message: errMsg });
    },
    onSettled: () => setLoading(false),
  });

  const handleResend = () => {
    if (!username) return;
    setLoading(true);
    mutate({ username_tx: username });
  };

  return (
    <div className="Auth-form-container">
      <form className="Auth-form" onSubmit={(e) => e.preventDefault()}>
        <h1 className="Auth-form-title text-white px-4 py-5">Check Your Email</h1>
        <div className="Auth-form-content py-3 px-4 otpWrapper">
          {message ? (
            <p className="text-success text-center my-3">
              {message}{" "}
              <button
                type="button"
                className="btn btn-link p-0 ms-1"
                disabled={loading}
                onClick={handleResend}
              >
                {loading ? "Resending..." : "Click here to resend"}
              </button>
            </p>
          ) : (
            <p className="text-muted text-center my-3">
              No message available, please try again.
            </p>
          )}
        </div>
      </form>
    </div>
  );
};

export default ResendEmail;